<template>
    <b-modal
        id="modal-batchcreator"
        ref="modal"
        size="lg"
        :title="this.formtitle"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
        @change="change"
    >
        <b-card @submit.stop.prevent="handleSubmit">
            <b-alert
                v-model="showDismissibleAlert"
                variant="danger"
                dismissible
            >
                {{ alertText }}
            </b-alert>
            <b-input-group
                :prepend="$t('prod_proddatum', { ns: 'production' })"
            >
                <b-form-datepicker
                    :date-format-options="{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit'
                    }"
                    :min="new Date()"
                    v-model="datum"
                ></b-form-datepicker>
            </b-input-group>
            <b-input-group :prepend="$t('com_kaassoort', { ns: 'common' })">
                <lookup-combo
                    :placeholder="
                        $t('com_kaassoort', {
                            ns: 'common'
                        })
                    "
                    v-model="selectedProductID"
                    v-bind:combotype="lctypeCheeses"
                    :disabled="true"
                ></lookup-combo>
            </b-input-group>
            <b-input-group :prepend="$t('prod_vorm', { ns: 'production' })">
                <lookup-combo
                    :placeholder="
                        $t('prod_vorm', {
                            ns: 'production'
                        })
                    "
                    v-model="selectedShapeID"
                    v-bind:combotype="lctypeShapes"
                    :disabled="true"
                ></lookup-combo>
            </b-input-group>
            <b-input-group :prepend="$t('prod_bakken', { ns: 'production' })">
                <b-form-input
                    :placeholder="$t('prod_bakken', { ns: 'production' })"
                    v-model.number="selectedAmount"
                ></b-form-input>
            </b-input-group>
        </b-card>
    </b-modal>
</template>
<script>
import DateHelper from '../../models/DateHelper';
import { LookupCombo } from '../components';
import { loadList, loadItem } from '../../models/DataHelper';
export default {
    name: 'ProductionBatchCreator',
    data: function () {
        return {
            lctypeCheeses: window.constants.LCCHEESE,
            lctypeShapes: window.constants.LCSHAPES,
            selectedProductID: null,
            selectedShapeID: null,
            selectedAmount: 1,
            showDismissibleAlert: false,
            alertText: '',
            forcerefresh: true,
            selected: [],
            datum: new Date()
        };
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        askedProdDate: {},
        askedProductID: {},
        askedShapeID: {},
        requestedAmount: {
            type: Number,
            default: 1
        },
        title: {
            type: String,
            default: ''
        }
    },
    watch: {},
    components: { LookupCombo },
    computed: {
        formtitle() {
            return this.title;
        }
    },
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        hide() {
            this.$emit('hide');
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        async handleSubmit() {
            await this.createBatches();
            if (this.selected.length === 0) {
                this.showAlert(
                    this.$t('com_geen_data', {
                        ns: 'common'
                    })
                );
                return;
            }
            // Hide the modal manually
            this.$nextTick(() => {
                this.$emit('input', this.selected);
                this.$bvModal.hide('modal-batchcreator');
            });
        },
        async createBatches() {
            let gaDoor =
                this.selectedAmount > window.constants.WARN_BAKKEN
                    ? false
                    : true;
            if (!gaDoor) {
                gaDoor = await this.$root.showConfirmationBox(
                    this.$t('prod_teveelbakken', {
                        ns: 'production',
                        val: this.selectedAmount
                    })
                );
            }
            // TODO check aantal kazen dat gemaakt wordt tov  requestedAmount
            if (gaDoor) {
                const selectionData = {
                    bookdate: DateHelper.localDateToUTC(this.datum),
                    prodLineID: window.constants.DEFPRODLINE,
                    productID: this.selectedProductID,
                    batches: this.selectedAmount,
                    shapeID: this.selectedShapeID
                };
                const lijst = await loadItem(
                    'production/addBatches',
                    selectionData,
                    this.$t
                );
                this.selectedAmount = 1;
                this.selected = lijst;
            }
        },
        change(visible) {
            this.$emit('change', visible);
        }
    },
    mounted() {},
    async created() {
        this.datum =
            this.askedProdDate != undefined
                ? DateHelper.convertedToDateTimeJS(this.askedProdDate)
                : new Date(new Date().toDateString());
        this.selectedProductID = this.askedProductID;
        this.selectedShapeID = this.askedShapeID;
    }
};
</script>

<style scoped></style>

